<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label>Tratamientos
                  <validacion>*</validacion>
                </label>
                <v-select :options="tratameintos" @input="agregarTratamientoPromocion()" v-model="txSeleccionado" label="nombre"
                          placeholder="Seleccion de tratamientos para aplicar en los descuentos de zonas"></v-select>

              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-table thead-tr-class="columnas" :items="tratamientos" :fields="columnasTx"
                       class="parrafos" small lazy>
                <template v-slot:cell(nombre)="row">
                  <div class="text-left">
                    {{ row.item.nombre }}
                  </div>
                </template>
                <template v-slot:cell(cantidadDescuento)="row">
                  <span v-if="idTipoDescuento === 1">
                    {{ row.item.cantidadDescuento + '%' }}
                  </span>
                  <span v-else>
                    {{ row.item.cantidadDescuento | moneda }}
                  </span>
<!--                  <b-form>
                    <b-form-input maxlength="3"
                                  @keypress="onlyNumber($event)"
                                  v-model.number="row.item.cantidadDescuento"
                                  type="number"
                                  min="1"
                                  :max="idTipoDescuento === 1 ? 100 : 32767"
                                  :state="(idTipoDescuento === 1 &&
                                          row.item.cantidadDescuento > 0 && row.item.cantidadDescuento <= 100) ||
                                          (idTipoDescuento !== 1 && row.item.cantidadDescuento > 0 && row.item.cantidadDescuento <= 32767)"
                                  class="form-control-sm mb-1 mt-1" style="width: 8vw"
                                  onpaste="return false">
                    </b-form-input>
                    <validacion
                        v-if="(idTipoDescuento === 1 &&
                                          !(row.item.cantidadDescuento > 0 && row.item.cantidadDescuento <= 100))"
                        texto="El porcentaje debe ser de 1 a 100"/>
                  </b-form>-->
                </template>
                <template v-slot:cell(Eliminar)="row">
                  <b-button size="sm" variant="danger" @click="eliminarTratamientos(row.item)"><em
                      class="fa fa-close"></em></b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  CatalogosService
} from "../../apiServices/catalogos/CatalogosService";
import {
  TratamientoService
} from "../../apiServices/tratamiento/TratamientoService";
import {
  required
} from "vuelidate/lib/validators";
import {
  PromocionesService
} from "../../apiServices/promociones/PromocionesService";

export default {
  catalogosService: new CatalogosService(),
  tratamientoService: new TratamientoService(),
  promocionesServicio: new PromocionesService(),
  name: "formularioTratamientos",
  components: {},
  props: {
    tratamientosOriginal: Array,
    idTipoDescuento: Number,
    cantidadDescuento: Number
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      tratameintos: [],

      tratamientos: [],

      columnasTx: [{
        key: "nombre",
        label: "Tratamiento",
        thClass: "w-50",
      },
        {
          key: "cantidadDescuento",
          label: "Descuento",
        },
        "Eliminar",
      ],
      txSeleccionado: null
    };
  },
  validations() {
    return {
      tratamientos: {
        required,
      },
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.tratamientos = JSON.parse(JSON.stringify(this.tratamientosOriginal));
    if (this.tratamientos.length !== 0) {
      this.tratamientos = this.tratamientos.filter(tx => tx.registroActivo !== false)
      this.tratamientos.forEach(tx => tx.cantidadDescuento = this.cantidadDescuento)
    }
    this.obtenerTratamientos();
  },
  methods: {
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    obtenerTratamientos() {
      this.$options.catalogosService
          .obtenerTratamientosConEspecilidades()
          .then((response) => {
            this.tratameintos = response;
          });
    },
    agregarTratamientoPromocion() {
      if (this.tratamientos.some(tx => tx.idTratamiento === this.txSeleccionado.idTratamiento)) {
        return;
      } else {
        let agregarTx;

        agregarTx = {
          idTratamiento: this.txSeleccionado.idTratamiento,
          nombre: this.txSeleccionado.nombre,
          cantidadDescuento: this.cantidadDescuento
        }
        this.tratamientos.push(agregarTx);
      }
      this.txSeleccionado = null;
    },

    eliminarTratamientos(e) {
      this.tratamientos.splice(
          this.tratamientos.indexOf(e),
          1
      );
    },
  },
  watch: {
    cantidadDescuento: function (val){
      if (val !== undefined || val !== null || val !== '') {
        if (this.tratamientos.length > 0) {
          this.tratamientos.forEach(tx => tx.cantidadDescuento = this.cantidadDescuento)
        }
      }
    }
  }
};
</script>

<style scoped>
.txSesion > .card-body {
  font-size: small !important;
  padding: 0.5rem !important;
}
</style>
